import { writable } from 'svelte/store';

export const CriteriaFiltered = writable([]);